module.exports = __webpack_public_path__ + "static/img/organilog-02.065e2dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-02.png
// module id = 119
// module chunks = 0